module.exports = __webpack_public_path__ + "img/emo_33.b468e6b9.png";